import { Navigate } from 'react-router-dom'
import React from 'react'
import API from '../api/API'

const RequireAuth = (props: { ele: React.ReactElement }) => {
  const isAuthenticated = API.isLogged()
  return isAuthenticated ? props.ele : <Navigate to='/signin' replace={true} />
}
export default RequireAuth
